import { render, staticRenderFns } from "./PersonalPop.vue?vue&type=template&id=030c3a38"
import script from "./PersonalPop.vue?vue&type=script&lang=js"
export * from "./PersonalPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports